/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EnterpriseIdDto } from './enterpriseIdDto';

export interface EnterpriseLicensesV2Dto {
  expiration?: string;
  owner?: EnterpriseIdDto;
  quantity?: number;
  quantityLIGHT?: number;
  quantityLIGHTUsed?: number;
  quantityPRO?: number;
  quantityPROUsed?: number;
  quantityULTIMATE?: number;
  quantityULTIMATEUsed?: number;
  quantityUsed?: number;
  silo?: boolean;
  syren?: boolean;
}
